import { render, staticRenderFns } from "./AssignedPixels.vue?vue&type=template&id=67bb5ed3"
import script from "./AssignedPixels.vue?vue&type=script&lang=js"
export * from "./AssignedPixels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports